import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import CustomCursor from "@/components/CustomCursor";
import ScrollReveal from "@/components/ScrollReveal";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import Stats from "@/components/Stats";
import Process from "@/components/Process";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AIChatWidget from "@/components/AIChatWidget";

function HomePage() {
  return (
    <div className="relative" data-testid="home-page">
      <CustomCursor />
      <ScrollReveal />
      <Navigation />
      <main>
        <Hero />
        <Services />
        <About />
        <Stats />
        <Process />
        <Contact />
      </main>
      <Footer />
      <AIChatWidget />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
